/* eslint-disable */

/*
Array of cities
*/
export const citiesArr = [
	{
		name: 'peterburg',
		title: 'Санкт-Петербург',
		cityIndex: 0,
		// In percentage!
		coordinates: {
			x: 9.6,
			y: 39.454,
		},
		// Pointer to the universityObjArr index
		universityPointerArr: [],
		// University:year
		// universityPointerArr: [{
		// 	'Воспитательное общество благородных девиц': 1764,
		// }],
	},
	{
		name: 'saratov',
		title: 'Саратов',
		cityIndex: 1,
		// In percentage!
		coordinates: {
			x: 27.723,
			y: 67.498,
		},
		// Pointer to the universityObjArr index
		universityPointerArr: [],
	},
	{
		name: 'tbilisi',
		title: 'Тифлис',
		cityIndex: 2,
		// In percentage!
		coordinates: {
			x: 27.494,
			y: 91.058,
		},
		// Pointer to the universityObjArr index
		universityPointerArr: [],
	},
	{
		name: 'warsaw',
		title: 'Варшава',
		cityIndex: 3,
		// In percentage!
		coordinates: {
			x: 2.5,
			y: 66,
		},
		// Pointer to the universityObjArr index
		universityPointerArr: [],
	},

	{
		name: 'orel',
		title: 'Орёл',
		cityIndex: 4,
		// In percentage!
		coordinates: {
			x: 18,
			y: 64,
		},
		// Pointer to the universityObjArr index
		universityPointerArr: [],
	},
	{
		name: 'moscow',
		title: 'Москва',
		cityIndex: 5,
		// In percentage!
		coordinates: {
			x: 19,
			y: 56,
		},
		// Pointer to the universityObjArr index
		universityPointerArr: [],
	},
	{
		name: 'harkov',
		title: 'Харьков',
		cityIndex: 6,
		// In percentage!
		coordinates: {
			x: 18.5,
			y: 70,
		},
		// Pointer to the universityObjArr index
		universityPointerArr: [],
	}
	, {
		name: 'poltava',
		title: 'Полтава',
		cityIndex: 7,
		// In percentage!
		coordinates: {
			x: 16.5,
			y: 71,
		},
		// Pointer to the universityObjArr index
		universityPointerArr: [],
	}, {
		name: 'odessa',
		title: 'Одесса',
		cityIndex: 8,
		// In percentage!
		coordinates: {
			x: 13,
			y: 79,
		},
		// Pointer to the universityObjArr index
		universityPointerArr: [],
	}, {
		name: 'orenburg',
		title: 'Оренбург',
		cityIndex: 9,
		// In percentage!
		coordinates: {
			x: 38.5,
			y: 67,
		},
		// Pointer to the universityObjArr index
		universityPointerArr: [],
	},
	{
		name: 'kiev',
		title: 'Киев',
		cityIndex: 10,
		// In percentage!
		coordinates: {
			x: 12,
			y: 70,
		},
		// Pointer to the universityObjArr index
		universityPointerArr: [],
	}, {
		name: 'tambov',
		title: 'Тамбов',
		cityIndex: 11,
		// In percentage!
		coordinates: {
			x: 30,
			y: 72,
		},
		// Pointer to the universityObjArr index
		universityPointerArr: [],
	}, {
		name: 'kerch',
		title: 'Керчь',
		cityIndex: 12,
		// In percentage!
		coordinates: {
			x: 19,
			y: 81,
		},
		// Pointer to the universityObjArr index
		universityPointerArr: [],
	}, {
		name: 'asstrahan',
		title: 'Астрахань',
		cityIndex: 13,
		// In percentage!
		coordinates: {
			x: 30,
			y: 80,
		},
		// Pointer to the universityObjArr index
		universityPointerArr: [],
	},
	{
		name: 'belostok',
		title: 'Белосток',
		cityIndex: 14,
		// In percentage!
		coordinates: {
			x: 4.5,
			y: 63,
		},
		// Pointer to the universityObjArr index
		universityPointerArr: [],
	},
	{
		name: 'kazan',
		title: 'Казань',
		cityIndex: 15,
		// In percentage!
		coordinates: {
			x: 33,
			y: 56.6,
		},
		// Pointer to the universityObjArr index
		universityPointerArr: [],
	},
	{
		name: 'irkutsk',
		title: 'Иркутск',
		cityIndex: 17,
		// In percentage!
		coordinates: {
			x: 89,
			y: 65,
		},
		// Pointer to the universityObjArr index
		universityPointerArr: [],
	}, {
		name: 'novocherkassk',
		title: 'Новочеркасск',
		cityIndex: 18,
		// In percentage!
		coordinates: {
			x: 22.5,
			y: 78,
		},
		// Pointer to the universityObjArr index
		universityPointerArr: [],
	},
	{
		name: 'nijniynovgorod',
		title: 'Нижний Новгород',
		cityIndex: 19,
		// In percentage!
		coordinates: {
			x: 26,
			y: 55,
		},
		// Pointer to the universityObjArr index
		universityPointerArr: [],
	},
	{
		name: 'ekaterinodar',
		title: 'Екатеринодар',
		cityIndex: 20,
		// In percentage!
		coordinates: {
			x: 21,
			y: 83,
		},
		// Pointer to the universityObjArr index
		universityPointerArr: [],
	},
];

/* eslint-enable */
